import { render, staticRenderFns } from "./GeofencingPage.vue?vue&type=template&id=6b27590c&scoped=true&"
import script from "./GeofencingPage.vue?vue&type=script&lang=js&"
export * from "./GeofencingPage.vue?vue&type=script&lang=js&"
import style0 from "./GeofencingPage.vue?vue&type=style&index=0&id=6b27590c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b27590c",
  null
  
)

export default component.exports